import React from 'react';
import { Component } from 'reflux';
import { actions } from 'actions';
import { TimezoneStore } from 'stores/TimezoneStore';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';

class TimezoneDropDown extends Component {
  state = { fields: [] }

  constructor(props) {
    super(props);

    this.mapStoreToState(TimezoneStore, this.timezoneChanged);
  }

  componentWillMount() {
    actions.getTimezones();
  }

  timezoneChanged = (fields) => ({ fields })

  onChange = (evt) => {
    this.props.onChange(evt);
    this.props.handleSave(this.props.name,false);
  }

  render() {
    return (
      <TableRow>
        <TableColumn>
          <strong>{this.props.title}</strong>
        </TableColumn>
        <TableColumn>
          <span className="pull-right">
            <select onChange={this.onChange} style={{width: '150px'}} value={this.props.value}>
              {this.state.fields.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </span>
        </TableColumn>
      </TableRow>
    );
  }
}

export { TimezoneDropDown };
